import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

@Component({
  selector: 'calsoft-configurable-product',
  templateUrl: './configurable-product.component.html',
  styleUrls: ['./configurable-product.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class ConfigurableProductComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  productId: any;
  setId: any;
  key: any;
  @Input()
  columns: ListColumn[] = [
    // { name: 'select', property: 'select', visible: true, isModelProperty: false },
    { name: 'Attribute Label', property: 'frontendLabel', visible: true, isModelProperty: true },
    { name: 'Frontend Input', property: 'frontendInput', visible: true, isModelProperty: true },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  elements: any;
  pageList: any;
  pageSizeValue: any;
  spinner: boolean;
  filterActive: boolean;
  search: any;

  firstFormGroup: UntypedFormGroup;

  secondFormGroup: UntypedFormGroup;
  visible: boolean=false;

  constructor(private dialogRef: MatDialogRef<ConfigurableProductComponent>,
    private productService: ProductService,
    private snackBar: MatSnackBar,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data, private router: Router) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

    console.log(data)

    this.productId = data.productId
    this.setId = data.setId
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  queryString:any;


  ngOnInit(): void {
    this.firstFormGroup = this.formBuilder.group({
      catalogProductSuperAttribute: this.formBuilder.array([
        this.productRelation()
      ]),
      catalogProductSuperLink: this.formBuilder.array([
        this.catalogProductSuperLink()
      ]),


    })

    this.secondFormGroup = this.formBuilder.group({
      manageStockSeperately: [0,Validators.required],
      managePriceSeperately: [0,Validators.required],
      manageImageSeperately:[0,Validators.required],
      manageDescriptionSeperately:[0,Validators.required],
      manageAdditionalInformationSeperately:[0,Validators.required],
      manageNameSeperately:[0, Validators.required],
    })

    this.associatedProductList=[];
    this.associatedProductListProductConfigured=[];
    console.log(this.firstFormGroup);

  }
  isLinear = false;

  close() {



    this.dialogRef.close({ event: 'close' })
  }

  
  goForward(stepper: MatStepper, index) {

    if(index==4){
      this.visible=true;
    }else{
      this.visible=false;
    }
    if (this.filterListMap.size == 0) {
      this.snackBar.open("Please Select Atleast one Attribute", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }
    else if (index == 1) {

    
      this.attributeSelectedList=[]
      this.filterMapAttribute = new Map<any, any>();
      stepper.next();
    }
    else if (index == 2) {
      if (this.filterMapAttribute.size != 0) {
        this.filterByAttribute();
        stepper.next();
      } else {
        this.snackBar.open("Please Select Atleast one ", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      }
    } else  if (index == 3) {

      if(this.associatedProductList.length == 0 ){
        this.snackBar.open("Please Select Atleast one Product", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      }else{
        stepper.next();
      }
     
    }
    else  if (index == 4) {

      this.associatedProductListProductConfigured.forEach(element => {
        element['manageDescriptionSeperately']=this.secondFormGroup.value.manageDescriptionSeperately;
        element['manageAdditionalInformationSeperately']=this.secondFormGroup.value.manageAdditionalInformationSeperately;
        element['manageStockSeperately']=this.secondFormGroup.value.manageStockSeperately;
        element['managePriceSeperately']=this.secondFormGroup.value.managePriceSeperately;
        element['manageImageSeperately']=this.secondFormGroup.value.manageImageSeperately;
        element['manageNameSeperately']=this.secondFormGroup.value.manageNameSeperately
      });
      this.firstFormGroup.setControl('catalogProductSuperLink', this.setValueCatalogProductSuperLink  (this.associatedProductListProductConfigured));
      console.log(this.firstFormGroup)
      stepper.next();
    }
    else {
      stepper.next();
    }




  }

  goBack(stepper: MatStepper, index) {
    
    if(index==4){
      this.visible=true;
    }else{
      this.visible=false;
    }
    stepper.previous();

    // if(index == 4){
    //   this.associatedProductListProductConfigured=[]
    //   this.associatedProductList=[]
    //   stepper.previous();
    // }else{
    //   stepper.previous();
    // }
    
  }
  public attributeListForProduct: any = [];

  filterMap = new Map<any, any>();
  filterListMap = new Map<any, any>();
  filterRequest: any = [];
  newArr: any = [];
  catalogProductSuperAttributeList: any = [];
  getSelectedAttribute(event) {
    this.catalogProductSuperAttributeList=[]
    this.filterRequest = [];
    this.filterMap.clear()
    this.filterListMap.clear();
    console.log(event);
    this.attributeListForProduct = event;

    this.firstFormGroup.reset();

    console.log("s", this.attributeListForProduct);

    this.attributeListForProduct.forEach((element, index) => {
      this.key = element.frontendLabel;
      let object = {
        productId: this.productId,
        attributeId: element.attributeId,
        position: index,
        storeId: 0,
        useDefault: 0,
        label: this.key

      }

      this.catalogProductSuperAttributeList.push(object);


      element['eavAttributeOption'].forEach((optionObject, index) => {


        if (this.filterMap.get(this.key) == undefined) {

          this.filterMap.set(this.key, optionObject['eavAttributeOptionValue'][0].value);

          let valueList = []

          valueList.push(this.filterMap.get(this.key));

          this.filterListMap.set(this.key, valueList);

        } else {
          this[this.key] = this.filterMap.get(this.key) + "," + optionObject['eavAttributeOptionValue'][0].value;

          this.filterMap.set(this.key, this[this.key]);

          let valueList = []



          valueList = this.filterMap.get(this.key).split(",");

          this.filterListMap.set(this.key, valueList);


        }



      });

    });

    this.firstFormGroup.setControl('catalogProductSuperAttribute', this.setValueproductRelation(this.catalogProductSuperAttributeList));
    console.log(this.firstFormGroup);

    // this.filterMap.forEach((val: string, key: string) => {
    //   const convMap = {};
    //   let valueList=[];
    //   valueList=val.split(',')
    //   convMap[key] = valueList;
    //   this.filterRequest.push(convMap);
    // });
    // console.log(this.filterRequest);
  }


  keyFilter: any;
  condition: any;
  attributeSelectedList=[];
  filterMapAttribute = new Map<any, any>();
  filterColumn(event, id, i,value) {
    this.condition = null;

    this.keyFilter = id + "_configurableProduct";
    if (event.checked) {
      this.attributeSelectedList.push(value);
      if (this.filterMapAttribute.get(this.keyFilter) == undefined) {
        this.filterMapAttribute.set(this.keyFilter, event.source.value);
      } else {
        this[this.keyFilter] = this.filterMapAttribute.get(this.keyFilter) + "#" + event.source.value;

        this.filterMapAttribute.set(this.keyFilter, this[this.keyFilter]);
      }

      //this.filterByAttribute();
    } else {
      
      this.condition = this.filterMapAttribute
        .get(this.keyFilter)
        .replace(event.source.value, "");

      let index = this.condition.length - 1;

      if (this.condition[index] == "#") {
        this.condition = this.condition.substring(0, index);

        this.filterMapAttribute.set(this.keyFilter, this.condition);
      } else if (this.condition.length == 0) {
        this.filterMapAttribute.delete(this.keyFilter);
      } else {
        this.filterMapAttribute.set(this.keyFilter, this.condition);
      }

    


 
      if (
        this.filterMapAttribute.get(this.keyFilter) != undefined &&
        this.filterMapAttribute.get(this.keyFilter).charAt(0) == "#"
      ) {
        this.condition = this.filterMapAttribute.get(this.keyFilter).slice(1);
        this.filterMapAttribute.set(this.keyFilter, this.condition);
      }

        if(this.condition.includes("##")){
          this.condition=  this.condition.replace("##", "#");
        this.filterMapAttribute.set(this.keyFilter, this.condition);
      }
      let indexForEntityId = this.attributeSelectedList.findIndex(x => x == value)
      this.attributeSelectedList.splice(indexForEntityId, 1);
      // if (this.filterMapAttribute.size != 0) {
      //   this.filterByAttribute();
      // }
    }
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterAttributeList: any = [];
  filterRequestFilter: any = [];
  newArrFilter: any = [];
  filterMapSelect = new Map<any, any>();
  sortParam: any = 'entityId' + "," + Constant.Dsc;
  filterByAttribute() {
    const convMap = {};
    this.newArrFilter = [];
    this.filterRequestFilter = [];
    this.filterMapAttribute.forEach((val: string, key: string) => {
      convMap[key] = val;
      this.filterRequestFilter.push({ [key]: val });

      this.newArrFilter = this.filterRequestFilter;
    });

    this.getAllProductsMatched(true);
  }

  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;

    this.getAllProductsMatched(true);
  }
  getAllProductsMatched(paginated) {
    this.filterAttributeList = [];
    this.spinner = true;
    this.productService
      .filterByCategoryId(
        this.setId,
        this.newArrFilter,
        this.page,
        this.size,
        this.sortParam
      )
      .subscribe((res) => {
        this.spinner = false;
        this.filterAttributeList = res['data']['productList']["content"];
        this.condition = res['data']['condition']['queryString']
        this.elements = res['data']['productList']['numberOfElements'];
        this.pageList = res['data']['productList']['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);

        if(!paginated){
          this.associatedProductList=[]
          this.associatedProductListProductConfigured=[]
        }
       

      }, (err) => {
        this.spinner = false;


      });
  }


  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive=false
      this.getAllProductsMatched(false);
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }


  }

  filterSelectObj = [
    // {
    //   name: 'CODE',
    //   property: 'attributeCode',
    //   type: 'text',
    //   position: 'firstValue',
    //   options: []
    // },
    {
      name: 'ATTRIBUTE LABEL',
      property: 'frontendLabel',
      type: 'text',
      position: 'secondValue',
      options: []
    },
    {
      name: 'FRONTEND INPUT',
      property: 'frontendInput',
      type: 'select',
      position: 'eighthValue',
      options: [{ viewValue: "Select", value: "select" },
      { viewValue: "Text Area", value: "textarea" },
      { viewValue: "Text", value: "text" },
      { viewValue: "Date", value: "date" },
      { viewValue: "Yes/No", value: "boolean" },
      { viewValue: "Multiple Select", value: "multiselect" },
      { viewValue: "Price", value: "price" },]
    },
  ]


  onFilterChange(value) {
    if (value == '') {
      this.getAllProductsMatched(false);
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      value =value.replace(/ /g, '?')

        let searchTerm=this.condition + ' AND (' +"name:" + '*' + value.trim() + '*'
        + " OR sku:" + '*' + value.trim() + '*' + ") "
   

      console.log(searchTerm.trim());
      
      this.filterOption(searchTerm.trim())
    }
  }

  
  public associatedProductList: any=[];
    
  public associatedProductListProductConfigured: any=[];
  onChange(isChecked: boolean,row) {
    
        if (isChecked) {
          this.associatedProductList.push(row.entityId);

          let object={
            entityId:row.entityId,
            name:row.name,
            sku:row.sku,
            manageStockSeperately:0,
            managePriceSeperately:0,
            manageImageSeperately:0,
            manageDescriptionSeperately:0,
            manageAdditionalInformationSeperately:0,
            manageNameSeperately:0
          }
          this.associatedProductListProductConfigured.push(object)
        } else {
          let indexForEntityId = this.associatedProductList.findIndex(x => x == row.entityId)
          this.associatedProductList.splice(indexForEntityId, 1);

          let indexForAssociatedProduct = this.associatedProductListProductConfigured.findIndex(x => x.entityId == row.entityId)
          this.associatedProductListProductConfigured.splice(indexForAssociatedProduct, 1);
    
        }    
      }



  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    this.productService.configProductFilter(event, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.filterAttributeList = res['data']['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }


  productRelation(): UntypedFormGroup {
    return this.formBuilder.group({
      productSuperAttributeId: ['',],
      productId: [''],
      attributeId: [''],
      position: ['',],
      catalogProductSuperAttributeLabel: this.formBuilder.group({
        valueId: new UntypedFormControl(0),
        storeId: new UntypedFormControl(0),
        useDefault: new UntypedFormControl(0),
        value: [''],


      }),
    });
  }




  catalogProductSuperLink(): UntypedFormGroup {
    return this.formBuilder.group({
      linkId: [0,],
      productId: ['',],
      parentId: ['',],
      manageStockSeperately: ['',],
      queryCondition: [''],
      managePriceSeperately: [''],
      manageImageSeperately: [''],
      manageDescriptionSeperately: [''],
      manageAdditionalInformationSeperately: [''],
      manageNameSeperately:[''],
    });
  }



  setValueproductRelation(productRelation: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    
    
    productRelation.forEach(productRelationObject => {

      formArray.push(this.formBuilder.group({
        productSuperAttributeId: 0,
        productId: productRelationObject['productId'],
        attributeId: productRelationObject.attributeId,
        position: productRelationObject.position,
        catalogProductSuperAttributeLabel:  {
          storeId: productRelationObject.storeId,
          valueId: 0,
          useDefault: 0,
          value:productRelationObject.label
        }
      })

      );
    });

    return formArray;
  }

  setValueCatalogProductSuperLink(productSuperLins: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    
    
    productSuperLins.forEach(productSuperLinkObject => {

      console.log(productSuperLinkObject);
      
      formArray.push(this.formBuilder.group({

        linkId: productSuperLinkObject.linkId,
        productId: productSuperLinkObject.entityId,
        parentId: this.productId,
        queryCondition:  this.condition ,
        manageStockSeperately: productSuperLinkObject.manageStockSeperately,
        managePriceSeperately: productSuperLinkObject.managePriceSeperately,
        manageImageSeperately: productSuperLinkObject.manageImageSeperately,
        manageDescriptionSeperately: productSuperLinkObject.manageDescriptionSeperately,
        manageAdditionalInformationSeperately: productSuperLinkObject.manageAdditionalInformationSeperately,
        manageNameSeperately:productSuperLinkObject.manageNameSeperately
 
      })

      );
    });

    return formArray;
  }

  //  setValueCatalogProductSuperAttributeLabel(productSuperAttributeLabel: any): FormArray {
  //   const formArray = new FormArray([]);

  //     formArray.push(this.formBuilder.group({
  //       productSuperAttributeId: 0,
  //       productId: productSuperAttributeLabel.productId,
  //       storeId: 0,
  //       useDefault: 0,
  //       value:productSuperAttributeLabel.value
  //     }));

  //   return formArray;
  // }


  //Patch Value for catalogEavAttribute
  setValueCatalogProductSuperAttributeLabel(productSuperAttributeLabel: any) {

    let productSuperAttributeLabelObject = {
      productSuperAttributeId: 0,
      productId: productSuperAttributeLabel.productId,
      storeId: 0,
      useDefault: 0,
      value: productSuperAttributeLabel.value
    }
    return productSuperAttributeLabelObject;
  }



 attributeProperyValidations = {
    'manageStockSeperately': [
      { type: 'required', message: 'Please fill out this field.' },
   
    ],
    'managePriceSeperately': [
      { type: 'required', message: 'Please fill out this field.' },

    ],
    'manageImageSeperately': [
      { type: 'required', message: 'Please fill out this field.' },

    ],
    'manageDescriptionSeperately': [
      { type: 'required', message: 'Please fill out this field.' },

    ],

    'manageAdditionalInformationSeperately': [
      { type: 'required', message: 'Please fill out this field.' },

    ],

    'manageNameSeperately':[
      { type: 'required', message: 'Please fill out this field.' },
    ]
  


  }

  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  finshPopup(){
    this.dialogRef.close({ event: 'add', data: this.firstFormGroup.value })
    
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
